var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _vm.pets.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "add-pet-link" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.add-pet-modal",
                        modifiers: { "add-pet-modal": true }
                      }
                    ],
                    attrs: { href: "javascript:void(0)" }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("pets.addPetAction")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.pets, function(pet) {
        return _c(
          "div",
          { key: pet.id },
          [_c("pet-component", { attrs: { petId: pet.id } })],
          1
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "add-pet-link" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.add-pet-modal",
                            modifiers: { "add-pet-modal": true }
                          }
                        ],
                        attrs: { href: "javascript:void(0)" }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("pets.addPetAction")) +
                            "\n                            "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "add-pet-modal",
                  attrs: {
                    id: "add-pet-modal",
                    "ok-title": "Speichern",
                    "cancel-title": "Abbrechen",
                    "hide-header": true,
                    "hide-footer": true
                  }
                },
                [_c("add-pet-component")],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6ea28ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6ea28ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetsComponent.vue
// module id = null
// module chunks = 